Vue.directive('mask', {
    params: ['options'],

    bind: function() {
        if (! this.params.options) {
            return;
        }

        if (this.params.options.mask.includes('number')) {
            this.params.options.blocks.number.mask = Number;
        }

        initMask(this.el, this.params.options);
    },

    update: function (newValue) {
        this.el.maskRef.unmaskedValue = newValue ? newValue : '';
    },

    unbind: function() {
        destroyMask(this.el);
    }
});

function fireEvent(el, eventName, data) {
    var event = document.createEvent('CustomEvent');
    event.initCustomEvent(eventName, true, true, data);

    el.dispatchEvent(event);
}

function initMask(el, opts) {
    el.maskRef = IMask(el, opts)
        .on('accept', function() {
            fireEvent(el, 'accept', el.maskRef);
        });
}

function destroyMask(el) {
    if (el.maskRef) {
        el.maskRef.destroy();
        delete el.maskRef;
    }
}

